import { Alert, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { translateError } from '@/shared/api/errors'

interface QueryErrorStateProps {
  /** `useQuery().error` — sabab matni shundan olinadi */
  error: unknown
  /** Odatda `() => void query.refetch()` */
  onRetry: () => void
  /** Sarlavha — sukut bo'yicha «Ro'yxatni yuklab bo'lmadi» */
  title?: string
  /** Ichma-ich joylashgan panellarda tashqi chekka kerak bo'ladi */
  style?: React.CSSProperties
}

/**
 * So'rov XATOSI — bo'sh ro'yxatdan AJRATILGAN holat.
 *
 * ⚠️ Bu komponent bir sababdan bor: xatoni ko'rsatmagan ekran «ma'lumot
 * yo'q» deb YOLG'ON gapiradi. So'rov yiqilganda massiv bo'sh qoladi va
 * jadval xotirjam «hali yozuv yo'q» yozadi — operator muammo yo'q deb
 * o'ylab, qayta urinmaydi. Uch narsa ham SHART:
 *   1. xato ekanligi (qizil),
 *   2. SABAB (server matni, «xatolik yuz berdi» emas),
 *   3. QAYTA URINISH — aks holda yagona chora F5 bo'lib qoladi.
 */
export function QueryErrorState({ error, onRetry, title, style }: QueryErrorStateProps) {
  const { t } = useTranslation()
  return (
    <Alert
      type="error"
      showIcon
      {...(style ? { style } : {})}
      message={title ?? t('dataTable.loadFailed')}
      description={translateError(error, t)}
      action={
        <Button size="small" onClick={onRetry}>
          {t('dataTable.retry')}
        </Button>
      }
    />
  )
}
